import type { EventDefinition } from './navigation';

export type OnboardingStartedProperties = {
  source: 'new_user' | 'force_gate';
};

export type OnboardingStageCompletedProperties = {
  stage:
    | 'platform_settings'
    | 'profile'
    | 'location'
    | 'connect_socials'
    | 'interest_topics'
    | 'interest_platforms'
    | 'claim_devnet'
    | 'simulation';
  durationMs: number;
  skipped?: boolean;
};

export type OnboardingCompletedProperties = {
  totalDurationMs: number;
};

export type OnboardingExitedProperties = {
  exitStage:
    | 'platform_settings'
    | 'profile'
    | 'location'
    | 'connect_socials'
    | 'interest_topics'
    | 'interest_platforms'
    | 'claim_devnet'
    | 'simulation';
  subScreen: string;
};

export const ONBOARDING_STARTED: EventDefinition<OnboardingStartedProperties> = {
  name: 'onboarding_started',
};

export const ONBOARDING_STAGE_COMPLETED: EventDefinition<OnboardingStageCompletedProperties> = {
  name: 'onboarding_stage_completed',
};

export const ONBOARDING_COMPLETED: EventDefinition<OnboardingCompletedProperties> = {
  name: 'onboarding_completed',
};

export const ONBOARDING_EXITED: EventDefinition<OnboardingExitedProperties> = {
  name: 'onboarding_exited',
};
